import React, { useState, useEffect } from "react";
import { Card, Avatar, Spin, Skeleton, Tooltip } from "antd";
import SupportRequestForm from "./components/util-components/SupportRequestForm";
import { ExportOutlined, CustomerServiceOutlined, BookOutlined, MessageOutlined } from "@ant-design/icons";
import { safeJSONParse } from "@salespark/toolkit";

import { Link } from "react-router-dom";

import "./supportRequest.css";

const SupportRequest = (props) => {
  const [authData, setAuthData] = useState(undefined);
  const [isLoading, setIsLoading] = useState(undefined);
  useEffect(() => {
    let _authData = getAuthDataFromStorage();
    if (_authData) {
      let _d = { email: _authData.email, name: _authData.name, picture: _authData.picture };
      setAuthData(_d);
    }
    setTimeout(() => setIsLoading(true), 600);
  }, []);

  const getAuthDataFromStorage = () => {
    try {
      return safeJSONParse(localStorage.getItem("SalesPark-AuthBasic"));
    } catch (e) {
      return undefined;
    }
  };

  const apiVersion = () => {
    if (props.apiVersion !== undefined) {
      return <span className="sp-footer__api"> (API: {props.apiVersion})</span>;
    }
    return null;
  };

  if (isLoading === undefined) {
    return (
      <div className="support-page">
        <div className="sp-loading">
          <Spin size="large" tip="Está quase..." spinning>
            <Skeleton active />
            <Card style={{ marginTop: 16 }}>
              <Skeleton active />
              <Skeleton active />
              <Skeleton active />
            </Card>
          </Spin>
        </div>
      </div>
    );
  }

  return (
    <div className="support-page">
      <div className="support-shell">
        <header className="sp-topbar">
          <img className="sp-topbar__logo" src="/img/logo.png" alt="SalesPark" />
          {!!authData?.name && (
            <div className="sp-user-chip">
              <Avatar src={authData?.picture} size={34}>
                {authData?.name?.charAt(0)?.toUpperCase()}
              </Avatar>
              <span className="sp-user-chip__text">
                Olá <strong>{authData?.name}</strong>!
              </span>
            </div>
          )}
        </header>

        <section className="sp-hero">
          <span className="sp-eyebrow">
            <CustomerServiceOutlined /> Suporte SalesPark
          </span>
          <h1 className="sp-title">
            <span className="grad">Pedido de Suporte</span>
          </h1>
          <p className="sp-sub">
            Usa este espaço para colocares a tua questão à nossa equipa. Estamos aqui para te ajudar com qualquer dúvida ou problema relacionado com a tua
            conta, compras, vendas ou utilização da plataforma.
            <br />
            <br />
            <strong>Descreve o que se passa com o máximo de clareza possível</strong>, para podermos responder-te de forma rápida e eficaz. A nossa equipa vai
            analisar o teu pedido e dar-te resposta assim que possível.
          </p>

          <Link to={{ pathname: "https://ajuda.salespark.io" }} target="_blank" className="sp-help-card">
            <span className="sp-help-card__icon">
              <BookOutlined />
            </span>
            <span className="sp-help-card__body">
              <span className="sp-help-card__title">Procura primeiro na Central de Ajuda</span>
              <span className="sp-help-card__desc">Muitas respostas já estão documentadas. Encontra a tua solução em segundos.</span>
            </span>
            <ExportOutlined className="sp-help-card__arrow" />
          </Link>
        </section>

        <section className="sp-form-card">
          <div className="sp-form-card__head">
            <span className="sp-form-card__icon">
              <MessageOutlined />
            </span>
            <span>
              <span className="sp-form-card__title">Descreve o teu pedido</span>
              <span className="sp-form-card__hint">Quanto mais detalhe nos deres, mais rápida será a resposta.</span>
            </span>
          </div>
          <div className="sp-form-card__body">
            <SupportRequestForm auth={authData} />
          </div>
        </section>

        <footer className="sp-footer">
          <Tooltip placement="top" title="Feito com amor e muito café">
            <span className="sp-footer__line">
              &copy; {new Date().getFullYear()} SalesPark - Feito com ❤️ e ☕ v2.5.1331{apiVersion()}
            </span>
          </Tooltip>
        </footer>
      </div>
    </div>
  );
};

export default SupportRequest;
